module.exports = __webpack_public_path__ + "img/zhAward-4.27e5616f.png";